import { IItemListItem, IStoreInfo } from '~apis/tax-invoice';
import { EmailResendItem, TaxInvoice } from '~models/tax-invoice';

import { PurposeType, TaxationType } from './type';

export const mapTaxInvoiceItemList = ({
  itemList,
}: {
  itemList: IItemListItem[];
  makeMinus?: boolean;
}) => {
  return itemList.map((item) => {
    return {
      name: item?.name?.trimEnd(),
      unitPrice: parseInt(item.unitPrice + '', 10) * (item.flag || 1),
      quantity: item.quantity ? parseInt(item.quantity + '', 10) : undefined,
      totalAmount: parseInt(item.totalAmount + '', 10) * (item.flag || 1),
      supplyAmount: parseInt(item.supplyAmount + '', 10) * (item.flag || 1),
      taxAmount: parseInt(item.taxAmount + '', 10) * (item.flag || 1),
      unit: item.unit,
      date: item.date,
    };
  });
};

export const mapTaxInoiveRawItemToIssueInvoiceItem = (
  invoice: TaxInvoice,
): {
  totalAmount?: number;
  taxAmount?: number;
  supplyValue?: number;
  itemList: IItemListItem[];
  taxationType: TaxationType;
  businessEntityInfo: {
    businessEntityId?: number;
  };
  counterPartInfo: {
    name: string;
  };
  contractorInfo: Partial<IStoreInfo>;
  supplierInfo: Partial<IStoreInfo>;
  purposeType: PurposeType | null;
  issueDate: string;
  writtenDate: string;
  approvalNo?: string;
  emailResends: EmailResendItem[];
  remark?: string;
} => {
  return {
    writtenDate: invoice.reportingDate,
    totalAmount: invoice.totalAmount,
    supplyValue: invoice.supplyValue,
    taxAmount: invoice.taxAmount,
    counterPartInfo: {
      name: invoice.counterPartCompanyName,
    },
    itemList: invoice.itemList.map((item) => {
      return {
        name: item.taxItemName,
        unitPrice: Number(item.unitPrice),
        totalPrice: Number(item.supplyValue) + Number(item.taxAmt),
        taxPrice: Number(item.taxAmt),
        supplyPrice: Number(item.supplyValue),
        quantity: Number(item.quantity) || 1,
        supplyValue: Number(item.supplyValue),
        taxAmount: Number(item.taxAmt),
        unit: item.standards,
      };
    }),
    taxationType: invoice.taxationType,
    businessEntityInfo: {
      businessEntityId: invoice.businessEntityId,
    },
    contractorInfo: {
      businessRegNo: invoice.contractorRegNumber,
      taxIdNumber: invoice.contractorEstablishNo,
      corpName: invoice.contractorCompanyName,
      corpCeo: [invoice.contractorName],
      corpAddress: invoice.contractorBusinessPlace,
      businessClass: invoice.contractorBusinessTypes,
      businessType: invoice.contractorBusinessTypes,
      members: [
        {
          name: invoice.contractorName,
          email: invoice.contractorEmail,
        },
      ],
    },
    supplierInfo: {
      businessRegNo: invoice.supplierRegNumber,
      taxIdNumber: invoice.supplierEstablishNo,
      corpName: invoice.supplierCompanyName,
      corpCeo: [invoice.supplierName],
      corpAddress: invoice.supplierBusinessPlace,
      businessClass: invoice.supplierBusinessTypes,
      businessType: invoice.supplierBusinessTypes,
      members: [
        {
          name: invoice.supplierName,
          email: invoice.supplierEmail,
        },
      ],
    },

    purposeType: invoice.purposeType,
    approvalNo: invoice.id,
    issueDate: invoice.issueDate,
    emailResends: [],
    remark: invoice.note,
  };
};
